class ContribuinteConfiguracao {
    constructor() {
        this.id = null;
        this.idCliente = null;
        this.idUsuario = null;
        this.idContribuinte = null;
        this.dataVigenciaInicial = null;
        this.dataVigenciaFinal = null;
        this.version = null;
        this.idBolSempreRetem = null;
        this.logomarca = null;
        this.msgObservacaoNota = null;
        this.msgDiscriminacaoServico = null;
        this.emailsAlternativos = null;
        this.idBolNaoReceberEmailNfsDaps = null;
        this.idBolNaoEnviarEmailNfsDaps = null;

        this.credenciamentoTipo = null;

    }
}
export default ContribuinteConfiguracao;